/**
*
* Mutations WebApp Orange
*
*/

import {
  UPDATE_PRODUCT_INFORMATIONS,
  UPDATE_CURRENT_PRODUCT,
  UPDATE_OPEN_PRODUCT,
  UPDATE_ADD_TO_CART_BUTTON_STATE,
  UPDATE_TRADUCTION
} from './types/mutationsTypes'

/**
*
* Mutations ProductFile Orange
*
*/

const mutations = {
  [UPDATE_PRODUCT_INFORMATIONS]: (state, productInformations) => {
    state.productInformations = productInformations
  },
  [UPDATE_CURRENT_PRODUCT]: (state, currentProduct) => {
    state.currentProduct = currentProduct
  },
  [UPDATE_CURRENT_PRODUCT]: (state, currentProduct) => {
    state.currentProduct = currentProduct
  },
  [UPDATE_OPEN_PRODUCT]: (state, openProduct) => {
    state.openProduct = openProduct
  },
  [UPDATE_ADD_TO_CART_BUTTON_STATE]: (state, status) => {

    const buttonStatus = {
      discretDisabled: {
        disabled: true,
        tabindex: -1,
        loading: false,
        discret: true
      },
      discretDisabledLoading: {
        disabled: true,
        tabindex: -1,
        loading: true,
        discret: true
      },
      disabled: {
        disabled: true,
        tabindex: -1,
        loading: false,
        discret: false
      },
      enabled: {
        disabled: false,
        tabindex: 1,
        loading: false,
        discret: false
      }
    }

    state.addToCartButtonState = buttonStatus[status]
  },
  [UPDATE_TRADUCTION]: (state, traduction) => {
    state.$t = traduction
  }
}

export default mutations